import React, { useEffect, useState } from "react";

import { FeatureType } from "components/paywall/paywallUtils";
import Modal from "components/ui/modal/Modal";
import { EventData, EventNames, useTracking } from "lib/tracking";
import { formatDataType } from "../../lib/utils";
import BookADemoForm from "./BookADemoForm";
import Subscription from "./Subscription";

type PaywallCTAModalProps = {
  isOpen: boolean;
  onClose: () => void;
  showBookADemoForm: boolean;
  featureType?: FeatureType;
};

export default function PaywallCTAModal({
  isOpen,
  onClose,
  showBookADemoForm,
  featureType,
}: PaywallCTAModalProps) {
  const [showBookADemo, setShowBookADemo] = useState(showBookADemoForm);
  const trackingData: EventData = {
    "Context source": showBookADemoForm ? "Book a demo form" : "Compare all plans modal",
    "Data type": featureType ?? formatDataType(window.location.href) ?? "N/A",
  };
  const { logEvent } = useTracking();

  useEffect(() => {
    setShowBookADemo(showBookADemoForm);
  }, [showBookADemoForm]);

  const onOpenChange = (open: boolean) => {
    if (!open) {
      if (showBookADemo) {
        logEvent(EventNames.bookADemoCancelled, {
          "Data type": formatDataType(window.location.href) ?? "N/A",
          ...trackingData,
        });
      }
      onClose();
    } else {
      console.warn("onOpenChange with open=true is unsupported in PaywallCTAModal");
    }
  };

  return (
    <Modal open={isOpen} onOpenChange={onOpenChange} maxWidth="calc(100vw - 60px)">
      {showBookADemo ? (
        <BookADemoForm trackingData={trackingData} />
      ) : (
        <Subscription triggerBookADemoForm={setShowBookADemo} trackingData={trackingData} />
      )}
    </Modal>
  );
}
